import { isEmpty, isNil, some } from 'lodash-es'
import React from 'react'

const STRING_SPLIT_REGEX = /(<.*?>)/
const STRING_MATCH_REGEX = /<(.*?)>/

const interpolateAsString = (string, map) => {
  if (!string) return ''
  let replacedString = string

  Object.keys(map).forEach((key) => {
    const regex = new RegExp(`<${key}>`, 'gi')
    replacedString = replacedString.replace(regex, map[key])
  })

  return replacedString
}

export const interpolate = (string, componentMap) => {
  if (string && some(componentMap, React.isValidElement)) {
    return (
      <>
        {string.split(STRING_SPLIT_REGEX).map((item, key) => {
          if (item.startsWith('<')) {
            const found = item.match(STRING_MATCH_REGEX)
            if (found) {
              return componentMap[found[1]] || null
            }
          }
          return item
        })}
      </>
    )
  }
  return interpolateAsString(string, componentMap)
}

export const sanitizeInput = (string) => {
  const tagsToReplace = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
  }

  function replaceTag(tag) {
    return tagsToReplace[tag] || tag
  }

  return string.replace(/[&<>]/g, replaceTag)
}

export const santizeInputFields = (pageResults) => {
  // legalBusinessName excluded: mid-tier decodes/unsanitizes it, so sanitizing here would leave it double-encoded
  const fieldsToBeSantized = [
    'lastName',
    'firstName',
    'doYouHaveAFundingCode',
    'personalPhoneNumber',
    'emailAddress',
    'homeAddress1',
    'homeAddress2',
    'city',
    'zip',
    'businessAddress1',
    'businessAddress2',
    'businessCity',
    'businessState',
    'businessZip',
    'businessPhoneNumber',
    'businessWebAddress',
    'businessEntityType',
    'doingBusinessAs',
    'totalAnnualBusinessRevenue',
    'businessStartDate',
    'numberOfFullTimeEmployees',
    'dateOfBirth',
    'socialSecurityNumber',
    'federalTaxId',
  ]
  if (!pageResults) {
    return
  }

  if (typeof pageResults === 'object') {
    Object.keys(pageResults).forEach((key) => {
      if (
        pageResults[key] !== undefined &&
        typeof pageResults[key] === 'object'
      ) {
        santizeInputFields(pageResults[key])
        return
      }

      if (!isNil(pageResults[key]) && !isEmpty(pageResults[key])) {
        if (fieldsToBeSantized.includes(key)) {
          pageResults[key] = sanitizeInput(pageResults[key])
        }
      }
    })
  } else if (typeof pageResults === 'string') {
    pageResults = sanitizeInput(pageResults)
  }
}
